import React from "react";
import { Switch } from "antd";
import TransferModal from "../../transactions/TransferModal";

const RestaurantControls = ({
  restaurantOpenState,
  handleSwitch,
  userProfile,
  onTransferComplete,
  loading,
}) => {
  return (
    <div className="flex justify-between mb-10 px-4">
      {/* Restaurant Transfer Modal */}
      {!userProfile?.business?.isSpecial && (
        <div className="flex space-x-4 my-auto">
          <TransferModal
            initialType="bank"
            isBusiness={true}
            onComplete={onTransferComplete}
          >
            <button
              className="bg_side_green"
              style={{ width: "fit-content " }}
            >
              Withdraw
            </button>
          </TransferModal>
        </div>
      )}
      {/* Restaurant Toggle Time */}
      {userProfile?.isRestaurantOwner && (
        <div className="h-full">
          <div className="flex align-center justify-end w-full space-x-5 py-4">
            <p
              className={`${
                !restaurantOpenState ? "text-[red]" : "text-black"
              } text-[14px]`}
            >
              {restaurantOpenState
                ? "Restaurant is Opened"
                : "Restaurant is Closed"}
            </p>
            <Switch
              className={`${
                restaurantOpenState ? "bg-[#258635]" : "bg-[grey]"
              }`}
              checked={restaurantOpenState}
              onChange={handleSwitch}
              disabled={loading}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RestaurantControls;
